import styled from 'styled-components';
import { Grid, defaultTheme } from '@kiwicom/orbit-components';

const Wrapper = styled.div`
  width: 100%;
`;
type Props = {
  readonly children: JSX.Element | JSX.Element[];
  readonly length: number;
  readonly gap?: string;
};

const GridWrapper = (props: Props): JSX.Element => {
  return (
    <Wrapper>
      <Grid
        as="div"
        gap={props.gap ?? defaultTheme.orbit.space400}
        tablet={{
          columns: '1fr 1fr',
          rows: `repeat(${Math.ceil(props.length / 2)}, auto)`,
          gap: props.gap ?? defaultTheme.orbit.space800,
        }}
        rows={`repeat(${props.length}, auto)`}
      >
        {props.children}
      </Grid>
    </Wrapper>
  );
};

export default GridWrapper;
